import { FC } from "react";
import { color as themeColor } from "@styles";
import { RegionalReward, RewardCardGrid } from "../../atoms/RewardCard";
import styled from "styled-components";

export const RewardCardTabSwitcherDesktop: FC<
  React.PropsWithChildren<{
    rewards: RegionalReward[];
    pb?: string;
    backgroundColor?: string;
  }>
> = ({ rewards, pb, backgroundColor }) => {
  return (
    <Container backgroundColor={backgroundColor}>
      <RewardCardGrid rewards={rewards} pl="0" pr="0" pt="2.5rem" pb={pb} />
    </Container>
  );
};

const Container = styled.div<{ backgroundColor?: string }>`
  position: relative;
  background: ${(p) => p.backgroundColor || themeColor.S310};
`;
